import React, { useState } from "react";
import { Button, Grid, Header, Icon, Input } from "semantic-ui-react";
import { getGeneralInfoData } from "../../../utils";
import { Field, Formik } from "formik";
import classNames from "classnames";
import styles from "./RecommendationSidebar.module.css";
import { validateRecommendationForm } from "../../../../../utils/recommendations";

const SidebarGeneralInformation = ({ currentTask, onEditTask }) => {
  const [isEditing, setIsEditing] = useState(false);
  const generalInfoData = currentTask ? getGeneralInfoData(currentTask) : [];
  const onSubmit = async values => {
    await onEditTask(values);
    setIsEditing(false);
  };

  return (
    <Grid.Row className="py-10">
      <Grid padded>
        <Grid.Row>
          <Grid.Column>
            <Header
              size="big"
              className={classNames("bold", styles.editableHeader)}
            >
              General information
              {!isEditing && (
                <Icon
                  name="edit"
                  className={styles.editIcon}
                  onClick={() => {
                    setIsEditing(true);
                  }}
                />
              )}
            </Header>
          </Grid.Column>
        </Grid.Row>
        {!isEditing ? (
          <>
            {generalInfoData.map(({ title, value }) => (
              <Grid.Row className="py-10" columns="equal">
                <Grid.Column>{title}</Grid.Column>
                <Grid.Column className="bold">{value || "—"}</Grid.Column>
              </Grid.Row>
            ))}
          </>
        ) : (
          <Formik
            validate={validateRecommendationForm}
            initialValues={currentTask}
            onSubmit={onSubmit}
          >
            {props => (
              <>
                {generalInfoData.map(
                  ({ title, value, key, options, ...rest }) => (
                    <Grid.Row
                      className="py-10"
                      verticalAlign="middle"
                      key={title}
                    >
                      <Grid.Column width={4}>{title}</Grid.Column>
                      <Grid.Column width={12}>
                        {rest.editable ? (
                          <Field
                            fluid
                            as={rest.as || Input}
                            action={rest.action}
                            type={rest.type}
                            name={key}
                            disabled={rest.disabled}
                          />
                        ) : (
                          <span className="bold">{value || "—"}</span>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  )
                )}
                <Grid.Row>
                  <Grid.Column>
                    <Button
                      onClick={() => {
                        setIsEditing(false);
                      }}
                      disabled={props.isSubmitting}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={
                        !props.dirty || !props.isValid || props.isSubmitting
                      }
                      onClick={props.handleSubmit}
                      color="green"
                    >
                      Save
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </>
            )}
          </Formik>
        )}
      </Grid>
    </Grid.Row>
  );
};

export default SidebarGeneralInformation;
